export enum LegendColors{
    CURRENT_ELEMENT = 'currentElement',
    COMPARABLE_ELEMENT = 'comparableElement',
    SWAPPING_ELEMENT = 'swappingElement',
    SORTED_ELEMENT = 'sortedElement',
    UNSORTED_ELEMENT = 'unsortedElement',
    MIN_VALUE = 'minValue',
    INITIAL_ELEMENT = 'initialElement'
}